export default "__VITE_PUBLIC_ASSET__031bf2b2__"